import { createContext } from 'react';
import { IUserState } from './userContext.provider';
import { ReducerAction } from './user.reducer';
type DispatchUser = (action: ReducerAction) => void;
export const UserStateContext = createContext<Partial<IUserState>>({});
export const UserDispatchContext = createContext<DispatchUser | undefined>(undefined);